import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";

// Import icons
import present from "../../assets/PresentCalender.png";
import halfday from "../../assets/halfday.png";
import absent from "../../assets/AbsentCalender.png";

const AttendanceCalendar = ({ month, year, attendance }) => {
  const date = dayjs(`${year}-${month}-01`);
  const daysInMonth = date.daysInMonth();
  const firstDay = date.startOf("month").day(); // weekday offset (0=Sunday)

  // Helper to get status for a day
 const getStatus = (day) => attendance?.[day] || null;


  const getIcon = (status) => {
    if (!status) return null;
    const normalized = status;
    if (normalized === "Present") return present;
    if (normalized === "Half Day") return halfday;
    if (normalized === "Absent") return absent;
    return null;
  };

  return (
    <Box sx={{ borderRadius: 2 }}>
      {/* Month Header */}
      <Box sx={{ backgroundColor: "#C7C7C7", py: 2 }}>
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            fontWeight: 600,
            color: "#01008B",
          }}
        >
          {date.format("MMMM YYYY")}
        </Typography>

        {/* Weekday labels */}
        <Grid container mt={2}>
          {["S", "M", "T", "W", "T", "F", "S"].map((d) => (
            <Grid item xs={12 / 7} key={d}>
              <Box
                sx={{
                  textAlign: "center",
                  fontWeight: 600,
                  py: 1,
                  color: "#000000",
                }}
              >
                {d}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Days */}
      <Grid container>
        {/* Empty slots before first day */}
        {Array.from({ length: firstDay }).map((_, idx) => (
          <Grid item xs={12 / 7} key={`empty-${idx}`} />
        ))}

        {Array.from({ length: daysInMonth }, (_, i) => {
          const day = i + 1;
          const status = getStatus(day);
          const icon = getIcon(status);

          const currentDate = dayjs();
          const isToday =
            currentDate.date() === day &&
            currentDate.month() + 1 === parseInt(month) &&
            currentDate.year() === parseInt(year);

          return (
            <Grid
              item
              xs={12 / 7}
              key={day}
              sx={{ borderBottom: "2px solid #C0BCBC" }}
            >
              <Box
                sx={{
                  height: 50,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: 14,
                  color:
                    status === "Present"
                      ? "green"
                      : status === "Absent"
                      ? "red"
                      : status === "Half Day"
                      ? "#01008B"
                      : "#000000",
                  gap: 0.5, // space between date and icon
                }}
              >
                {day}
                {icon && (
                  <Box
                    component="img"
                    src={icon}
                    alt={status}
                    sx={{
                      width: 14,
                      height: 14,
                    }}
                  />
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default AttendanceCalendar;
